module.exports = __webpack_public_path__ + "img/9.b27e1c76.jpg";